import script from "./AddOptionSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddOptionSection.vue?vue&type=script&lang=ts&setup=true"

import "./AddOptionSection.vue?vue&type=style&index=0&id=c7951ab2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7951ab2"]])

export default __exports__